import { ref } from 'vue';
import { getWebSearchPricing } from '../services/webSearchPricingService';

const pricing = ref({ enabled: false, requestCostEur: 0 });
const loaded = ref(false);
let inflight = null;

/**
 * Il prezzo/enabled è configurabile in admin in qualunque momento: non va
 * mai servito da cache oltre la durata della singola richiesta, altrimenti
 * un componente montato prima di una modifica in admin resta bloccato sul
 * valore vecchio per tutta la sessione SPA (nessun reload di pagina tra
 * admin e editor del bot).
 */
export function useWebSearchPricing() {
  const fetchPricing = async () => {
    if (inflight) return inflight;

    inflight = (async () => {
      try {
        const res = await getWebSearchPricing();
        if (res && res.success && res.data) {
          pricing.value = {
            enabled: !!res.data.enabled,
            requestCostEur: Number(res.data.requestCostEur) || 0,
          };
        }
        loaded.value = true;
      } catch (err) {
        Console.error('[useWebSearchPricing] fetch failed:', err);
      } finally {
        inflight = null;
      }
      return pricing.value;
    })();

    return inflight;
  };

  return { pricing, loaded, fetchPricing };
}
